import { LockKeyholeOpen, Ticket, UserPlus } from 'lucide-react';
import React from 'react';
import { cn } from '../../lib/utils';

const ReferralStep: React.FC<{
  refAmount?: string;
  refRewardType?: string;
}> = ({ refAmount, refRewardType }) => {
  const steps = [
    {
      label: 'Share your referral link',
      icon: UserPlus
    },
    {
      label:
        'Ensure your friends complete their AyeFace registration through your referral link',
      icon: LockKeyholeOpen
    },
    {
      label: `Receive ${refAmount || '[amount]'} ${refRewardType || '[reward type]'} once your friend spends with AyeFace`,
      icon: Ticket
    }
  ];
  return (
    <div className="mt-8 flex flex-col gap-4">
      <h3 className="text-center">How Referrals Work</h3>

      <ol className="relative ml-2 mt-1 border-s border-[#B7A9A680]">
        {steps.map((step, index) => (
          <li
            key={index}
            className={cn(
              'ms-8 flex items-center',
              index === steps.length - 1 ? 'mb-0' : 'mb-5'
            )}
          >
            <div className="absolute -start-4 h-8 w-8 rounded-full border bg-white shadow-lg shadow-black/20">
              <step.icon className="absolute left-1/2 top-1/2 h-4 w-4 -translate-x-1/2 -translate-y-1/2 transform text-primary" />
            </div>
            <p className="mb-1 text-sm font-normal leading-none">
              {step.label}
            </p>
          </li>
        ))}
      </ol>

      <p className="mt-6 text-sm">
        Your friend will receive their reward after completing the registration
        and linking at least one payment method to their AyeFace account. They
        can use the rewards at merchant locations with AyeFace Basic/Pro plans.
      </p>
    </div>
  );
};

export default ReferralStep;
